import { useMemo } from 'react';
import { FinanceProductSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): FinanceProductSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return FinanceProductSortingField.Company;

        case 'identity':
            return FinanceProductSortingField.Identifier;

        case 'displayName':
            return FinanceProductSortingField.DisplayName;

        case 'type':
            return FinanceProductSortingField.FinanceProductType;

        case 'bank.displayName':
            return FinanceProductSortingField.Bank;

        case 'period.start':
            return FinanceProductSortingField.StartDate;

        case 'period.end':
            return FinanceProductSortingField.EndDate;

        case 'order':
            return FinanceProductSortingField.Order;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === FinanceProductSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const identifierSort = useMemo(
        () => (sort.field === FinanceProductSortingField.Identifier ? sort.orderValue : undefined),
        [sort]
    );

    const displayNameSort = useMemo(
        () => (sort.field === FinanceProductSortingField.DisplayName ? sort.orderValue : undefined),
        [sort]
    );

    const financeProductTypeSort = useMemo(
        () => (sort.field === FinanceProductSortingField.FinanceProductType ? sort.orderValue : undefined),
        [sort]
    );

    const bankSort = useMemo(
        () => (sort.field === FinanceProductSortingField.Bank ? sort.orderValue : undefined),
        [sort]
    );

    const startDateSort = useMemo(
        () => (sort.field === FinanceProductSortingField.StartDate ? sort.orderValue : undefined),
        [sort]
    );

    const endDateSort = useMemo(
        () => (sort.field === FinanceProductSortingField.EndDate ? sort.orderValue : undefined),
        [sort]
    );

    const orderSort = useMemo(
        () => (sort.field === FinanceProductSortingField.Order ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        identifierSort,
        displayNameSort,
        financeProductTypeSort,
        bankSort,
        startDateSort,
        endDateSort,
        orderSort,
    };
};

export default useSortOrder;
